<aside class="sidebar-shell-wrapper d-flex flex-column flex-shrink-0 position-relative">

  <!-- BRAND HEADER -->
  <div class="sidebar-header d-flex align-items-center gap-3">
    <SidebarBrand
      :logo="logo"
      :title="brand_title"
      :subtitle="brand_subtitle"
      @brand-click="$emit('brand-click')"
    />

    <!-- 🔴 MOBILE CLOSE ACTION -->
    <slot name="sidebar-header-actions"></slot>
  </div>

  <hr class="border-bottom border-white border mt-0">

  <!-- CONTEXT BLOCK -->
  <slot name="context"></slot>

  <hr class="border-bottom border-white border mb-0">

  <!-- ========== SCROLL AREA ========== -->
  <div class="sidebar-scroll-area flex-grow-1 overflow-auto overflow-x-hidden">

    <!-- MENU BLOCK -->
    <slot name="menu"></slot>

    <!-- AFTER MENU BLOCK -->
    <slot name="after-menu"></slot>

  </div>

  <!-- ========== FOOTER (USER INFO) ========== -->
  <SidebarUserFooter
    :initials="initials"
    :full_name="full_name"
    :is_admin="is_admin"
  />

</aside>
